<h1 mat-dialog-title [attr.data-cy]="'tatdatd_h1_1_4_'">
    {{ tour && tour.bestellung_id ? "Tour editieren" : "Eine neue Tour hinzufügen" }}
</h1>
<div mat-dialog-content>
    <div class="one-row">
        <button
            style="height: 46px; margin-right: 5px; margin-bottom: 16px"
            mat-flat-button
            color="accent"
            (click)="openKWDialog()"
            matTooltip="Kalenderwoche auswählen"
            [attr.data-cy]="'tatdatd_button_1_0_'"
        >
            KW
        </button>
        <mat-form-field style="margin-right: 12px" [attr.data-cy]="'tatdatd_mat-form-field_1_8_'">
            <input
                matInput
                [matDatepicker]="pickerFrom"
                placeholder="Zieldatum von"
                [formControl]="zieldatumFromCtrl"
                autofocus
                [attr.data-cy]="'tatdatd_input_1_1_'"
            />
            <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
            <mat-datepicker #pickerFrom></mat-datepicker>
        </mat-form-field>
        <mat-form-field [attr.data-cy]="'tatdatd_mat-form-field_2_8_'">
            <input
                matInput
                [matDatepicker]="pickerTo"
                placeholder="Zieldatum bis"
                [formControl]="zieldatumToCtrl"
                [attr.data-cy]="'tatdatd_input_2_1_'"
            />
            <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
            <mat-datepicker #pickerTo></mat-datepicker>
        </mat-form-field>
        <span class="spacer" [attr.data-cy]="'tatdatd_span_1_16_'"></span>
    </div>
    <div *ngIf="showKunde">
        <mat-checkbox
            *kienePermission="[1168]"
            [formControl]="apothekeCtrl"
            [attr.data-cy]="'tatdatd_mat-checkbox_1_3_'"
            >Über Apotheke
        </mat-checkbox>
        <p style="font-size: 14px; font-weight: bold; color: #aaa">
            Entweder eine Unternehmensgruppe oder einen Kunden eingeben
        </p>
        <div class="one-row">
            <div style="width: 40%">
                <kiene-company-group-autocomplete
                    #companyGroupAuto
                    [companyGroup]="currentCompanyGroup"
                    (selectedCompanyGroup)="setUnternehmensgruppe($event)"
                    [attr.data-cy]="'tatdatd__autocomplete_1_0_'"
                ></kiene-company-group-autocomplete>
            </div>
            <div>oder</div>
            <div style="width: 40%">
                <kiene-client-autocomplete
                    [panelWidth]="'50%'"
                    [client]="currentClient"
                    [placeholder]="'Kunde'"
                    [showVVVO]="true"
                    [mandantMitarbeiterSuche]="mandantMitarbeiterSuche"
                    (selectedClient)="setClient($event)"
                    [onlyActiveClients]="true"
                    [attr.data-cy]="'tatdatd_autocomplete_2_0_'"
                >
                </kiene-client-autocomplete>
            </div>
        </div>

        <mat-divider></mat-divider>
        <mat-form-field style="width: 100%" [attr.data-cy]="'tatdatd_mat-form-field_3_8_'">
            <textarea matInput [formControl]="notizCtrl" rows="3" placeholder="Notiz hinzufügen..."></textarea>
        </mat-form-field>
    </div>
    <h4>Artikel</h4>
    <table class="phito-table">
        <thead>
            <tr>
                <th></th>
                <th>Artikel</th>
                <th>Menge</th>
                <th>Anzahl Tiere</th>
                <th>Identifikation</th>
                <th></th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let am of artikelMenge; let i = index">
                <td></td>
                <td style="width: 50%">{{ am.article.artikel_me }}</td>
                <td style="width: 10%">{{ am.menge | number: "1.0-1" }}</td>
                <td style="width: 10%">
                    {{ am.anzahl_tiere | number: "1.0-0" }}
                </td>
                <td style="width: 20%">{{ am.identifikation }}</td>
                <td style="width: 10%">
                    <button
                        mat-icon-button
                        [matMenuTriggerFor]="artikelMenu"
                        [attr.data-cy]="'tatdatd_button_2_0_' + i"
                    >
                        <mat-icon [attr.data-cy]="'tatdatd_mat-icon_1_2_' + i">more_vert</mat-icon>
                    </button>
                    <mat-menu #artikelMenu="matMenu">
                        <button mat-menu-item (click)="editArtikel(am)" [attr.data-cy]="'tatdatd_button_3_0_' + i">
                            <mat-icon [attr.data-cy]="'tatdatd_mat-icon_2_2_' + i">edit</mat-icon>
                            <span [attr.data-cy]="'tatdatd_span_2_16_' + i">Bearbeiten</span>
                        </button>
                        <button mat-menu-item (click)="removeArtikel(am)" [attr.data-cy]="'tatdatd_button_4_0_' + i">
                            <mat-icon [attr.data-cy]="'tatdatd_mat-icon_3_2_' + i">delete</mat-icon>
                            <span [attr.data-cy]="'tatdatd_span_3_16_' + i">L&ouml;schen</span>
                        </button>
                    </mat-menu>
                </td>
            </tr>
        </tbody>
    </table>

    <table style="width: 100%">
        <tbody>
            <tr>
                <td></td>
                <td style="width: 50%">
                    <kiene-article-scan-autocomplete
                        #articleAuto
                        [focus]="false"
                        [placeholder]="'Artikel'"
                        (selectedMaterial)="setSelectedMaterial($event)"
                        [gesperrtAusblenden]="true"
                    >
                    </kiene-article-scan-autocomplete>
                </td>
                <td style="width: 5%">
                    <mat-form-field style="width: 100px" [attr.data-cy]="'tatdatd_mat-form-field_4_8_'">
                        <mat-label [attr.data-cy]="'tatdatd_mat-label_1_9_'">Menge</mat-label>
                        <input
                            #menge="matInput"
                            matInput
                            type="number"
                            min="0.0001"
                            [max]="maxArtikelmenge"
                            step="any"
                            [formControl]="mengeCtrl"
                            (blur)="setFocusToAnzahlTiere()"
                            (keyup.enter)="setFocusToAnzahlTiere()"
                            [attr.data-cy]="'tatdatd_input_3_1_'"
                        />
                        <mat-error *ngIf="mengeCtrl.hasError('max')"
                            >Max. {{ maxArtikelmenge }}</mat-error
                        >
                    </mat-form-field>
                </td>
                <td style="width: 5%">
                    <mat-form-field style="width: 120px" [attr.data-cy]="'tatdatd_mat-form-field_5_8_'">
                        <mat-label [attr.data-cy]="'tatdatd_mat-label_2_9_'">Anzahl Tiere</mat-label>
                        <input
                            #anzahlTiere="matInput"
                            matInput
                            type="number"
                            [formControl]="anzahlTiereCtrl"
                            (blur)="setFocusToIdentification()"
                            (keyup.enter)="setFocusToIdentification()"
                            [attr.data-cy]="'tatdatd_input_4_1_'"
                        />
                    </mat-form-field>
                </td>
                <td style="width: 30%">
                    <mat-form-field [attr.data-cy]="'tatdatd_mat-form-field_6_8_'">
                        <mat-label [attr.data-cy]="'tatdatd_mat-label_3_9_'">Identifikation</mat-label>
                        <input
                            #identifikation="matInput"
                            matInput
                            type="text"
                            [formControl]="identifikationCtrl"
                            (keyup.enter)="addPositionToList()"
                            (blur)="addPositionToList()"
                            [attr.data-cy]="'tatdatd_input_5_1_'"
                        />
                    </mat-form-field>
                </td>
                <td style="width: 10%">
                    <button
                        mat-icon-button
                        color="accent"
                        (click)="addPositionToList()"
                        [attr.data-cy]="'tatdatd_button_5_0_'"
                    >
                        <mat-icon [attr.data-cy]="'tatdatd_mat-icon_4_2_'">add_circle</mat-icon>
                    </button>
                </td>
            </tr>
        </tbody>
    </table>
</div>
<div mat-dialog-actions>
    <button mat-button (click)="cancel()" [attr.data-cy]="'tatdatd_button_6_0_'">Abbrechen</button>
    <button mat-flat-button color="accent" (click)="save()" [attr.data-cy]="'tatdatd_button_7_0_'">
        {{ tour && tour.bestellung_id ? "Speichern" : isKunde ? "Bestellen" : "Hinzufügen" }}
    </button>
</div>
